import api, { INTEGRATION_HEALTH_TYPE, LIST } from '../Api';
import { IIntegrationHealthReport } from '../../models/IntegrationHealth';

// Integration health rollup (AC-1067): which of the organization's integrations are connected, which
// are failing (and why), which cannot be checked, and when each last moved data. One document per
// organization, so a single list tag; the simpleValidate mutations in Api.ts invalidate it so a
// re-check refreshes the home widget with the outcome the user just saw.
const integrationHealthApi = api.injectEndpoints({
    endpoints: (build) => ({
        getIntegrationHealth: build.query<IIntegrationHealthReport, void>({
            query: () => 'settings/integrationhealth',
            providesTags: [{ type: INTEGRATION_HEALTH_TYPE, id: LIST }]
        }),
    }),
    overrideExisting: false,
});

export const {
    useGetIntegrationHealthQuery,
} = integrationHealthApi;
